import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.button`
  //position: absolute;
  //top: 5%;
  //left: 2rem;
  ${respondTo.desktop`
    display: none;
  `}
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 18px;
  height: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  div {
    width: 18px;
    height: 1.6px;
    // background: ${({ open }) => (open ? '#0D0C1D' : '#EFFFFA')};
    background: #effffa;
    border-radius: 10px;
    transition: all 0.2s linear;
    position: relative;
    transform-origin: 3px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;
